<template>
	<div v-if="hasAnyPermission('sap-configuration-view')">
    <div class="py-4 container-fluid">
      <div class="row">
        <div class="col-12">
          <div class="card" style="height: 655px;">
            <!-- Card header -->
            <div class="card-header py-3">
              <div class="d-lg-flex align-items-center row">
                <h5 class="col-8	 font-weight-bolder">SAP Sync</h5>
                <div class="col-4">
                  <input v-model="sync.search" class="form-control rounded-pill text-center" type="text" placeholder="Search Data Sync" @keyup="filter">
                </div>
              </div>	
            </div>
            <!-- Card Body -->
            <div class="card-body">
							<div v-if="!sync.onLoad">
								<div class="row">
									<div v-for="(sync, i) in sync.data" :key="i" class="col-xl-3 col-md-6 my-3">
										<div class="card bg-gradient-primary border-0">
											<div class="card-body">
												<div class="row"> 
													<div class="col-8">
														<h6 class="card-title text-uppercase mb-0 text-white">{{sync.sync_name}}</h6>
														<!-- <span class="h2 font-weight-bold mb-0 text-white">{{sync.last_sync_at}}</span> -->
													</div>
													<div v-if="hasAnyPermission('sap-sync-task-synchron')" class="col-4 float-end">
														<button data-toggle="dropdown" class="btn btn-icon shadow btn-white mb-0" :disabled="(onSync[i] == 1)" @click="synchronize(sync.code, sync.id, i)">
															<i v-if="!onSync[i]" class="fas fa-sync text-neutral"></i>
															<i v-else class="fas fa-sync fa-spin text-neutral"></i>
														</button>                                                                                                            
													</div>
												</div>                                            
											</div>
										</div>
									</div>
								</div>
							</div>
							<div v-else>
								<SkeletonLoading
									class="px-4 pt-5"
									:shapes="[
										{ type: 'line', width: '100%', height: '20px' },
										{ type: 'line', width: '80%', height: '20px' },
										{ type: 'line', width: '60%', height: '20px' },
									]"
								/>
							</div>
            </div>
            <div class="card-footer pb-0">
							<span class="float-start">
								<BasePagination v-model="sync.page.current_pages" :page-count="sync.page.total_pages" size="sm" @click="changePage()"/>
              </span>
              <span class="float-end">
                {{ sync.total }} of {{ sync.total }}
              </span>
            </div>
          </div>
        </div>
      </div>
    </div>

  </div>
  <NoAccess v-else />
</template>
<script>
import { mapState } from "vuex";
import NoAccess from "@/components/NoAccess.vue";
import SkeletonLoading from "@/components/SkeletonLoading.vue";
import BasePagination from "@/components/BasePagination.vue";

import api from '@/helpers/api';
import sapSyncService from '@/services/sap/sapSyncService';
import sapSyncTaskService from '@/services/sap/sapSyncTaskService';

export default {
	components: {
    BasePagination,
    SkeletonLoading,
    NoAccess,
  },
	computed: {
		...mapState({
			authUserPermissions: (state) => state.auth.userHasPermissions || [],
		}),
	},
	data() {
		return {      
			loadTimeout: null,  
			btnSave: {
					onLoading: false
			},             
			form: {
					add: true,
					title: "Create Department",
					show: false
			}, 
			sync: {
					search: (this.$route.query.search) ? this.$route.query.search : '',
					data: [],
					onLoad: true,
					page: {
            current_pages: 1,
					},
					total: 0,
			},     
			onSync: [],
			errorMessage: null,   
			department: {},
			holdingCode: {},
		}
	},
	mounted() {
			if (this.hasAnyPermission('sap-configuration-view')) {
				this.get()
			}
	},
	methods: {
		hasAnyPermission(...perms) {
			return perms.some((p) => this.authUserPermissions.includes(p));
		},
		async get() {
			try {
				const response = await api(this, sapSyncService.list({page: this.sync.page.current_pages, search: this.sync.search}), false)
				const data = Array.isArray(response.data) ? response.data.filter((v) => v.function_type === 'pipo') : [];
				this.sync.data = data;
				this.sync.total = data.length;
        // this.sync.page = response.data;
			} catch (error) {
				if (error.response?.data?.code == 400) {
					error.response.data.data.forEach((v) => {
						this.$toastNotifPrime('error', error.response.data.message, v.msg)
					})
				}
			} finally {
				this.sync.onLoad = false
			}
		},
		filter() {
			if(this.sync.search != this.$route.query.search){
				clearTimeout(this.loadTimeout);
				this.loadTimeout = setTimeout(() => {
					if(this.sync.search == ''){
						this.$router.push({ query:null })
					}else{
						this.$router.push({ query:{search:this.sync.search }})
					}
					this.get()
				}, 100);
			}
		},
		async synchronize(sap_sync, sap_sync_id, i) {
			this.onSync[i] = 1
			try {
				await api(this, sapSyncTaskService.synchron(sap_sync, sap_sync_id, {force: 1}))
			} catch (error) {
				if (error.response?.data?.code == 400) {
					error.response.data.data.forEach((v) => {
						this.$toastNotifPrime('error', error.response.data.message, v.msg)
					})
				}
			} finally {
				this.onSync[i] = 0
			}
		},
		changePage() {
      clearTimeout(this.loadTimeout);
      this.loadTimeout = setTimeout(() => {
        this.get()
      }, 100);
    },
	}
}
</script>
